<template>
  <StyledText :fontId="fontId" tag="p" ref="targetEl" :class="[testClassName]">
    {{ overideText || text }}
  </StyledText>
</template>

<script lang="ts">
import StyledText from "./styled/Text.vue";
import { defineComponent, computed, PropType } from "vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import {
  injectAdTag,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { Brand } from "@fresh8/types/src/index";

export default defineComponent({
  name: "Text",
  components: {
    StyledText
  },
  props: {
    styleGroup: {
      type: String,
      required: true
    },
    overideText: {
      type: [String, Boolean],
      required: false
    },
    get: {
      type: Function as PropType<
        (brand: Brand) => { value: string; font: string }
      >,
      required: true
    }
  },
  setup(props) {
    const { brand } = injectBrand();
    const fontId = computed(() => props.get(brand.value).font);
    const { operator } = injectAdTag();
    const { targetEl } = composePopoverForm(props.styleGroup, [
      {
        type: "text",
        get: () =>
          props.get(brand.value).value || Object.keys(brand.value.fonts)[0],
        set: (value: string) => (props.get(brand.value).value = value)
      },
      {
        type: "font",
        get: () => props.get(brand.value).font,
        set: (value: string) => (props.get(brand.value).font = value)
      }
    ]);

    return {
      targetEl,
      fontId,
      text: computed(() =>
        props.get(brand.value).value.replace("%operator%", operator.value.name)
      ),
      testClassName: computed(
        () =>
          "text-style-" +
          props.styleGroup
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/[^A-z-]/g, "")
      )
    };
  }
});
</script>
